<template>
    <VTable
        v-bind:rounded="true"
        v-bind:striped="true"
        class="fantasy-bets-table notranslate"
    >
        <VTableRow class="vTable-sticky">
            <VTableHeader
                v-for="column in columns"
                v-bind:key="column.text"
                v-bind:width="column.width"
            >
                {{ column.text }}
            </VTableHeader>
        </VTableRow>

        <VTableRow v-if="!isLoaded">
            <VTableCell v-bind:colspan="columns.length" class="noBets">
                <div class="loadingOverlay">
                    <StaticSpinner />
                </div>
            </VTableCell>
        </VTableRow>
        <VTableRow v-else-if="bets.length === 0">
            <VTableCell v-bind:colspan="columns.length" class="noBets">
                <strong>
                    {{ i18n.t('no_bets_found') }}
                </strong>
            </VTableCell>
        </VTableRow>
        <template v-else>
            <MyBetRow
                v-for="(bet, index) in bets"
                v-bind:key="bet.refNo"
                v-bind:bet="bet"
                v-bind:index="index"
            />
        </template>
    </VTable>
</template>

<script lang="ts" setup>
    import StaticSpinner from '@/components/common/StaticSpinner.vue';
    import VTable from '@/components/common/table/VTable.vue';
    import VTableCell from '@/components/common/table/VTableCell.vue';
    import VTableHeader from '@/components/common/table/VTableHeader.vue';
    import VTableRow from '@/components/common/table/VTableRow.vue';
    import MyBetRow from '@/components/fantasySelection/myBets/MyBetRow.vue';
    import { i18n } from '@/core/lib/i18n';
    import type { IBet } from '@/interface/IFantasySelectionMyBets';

    defineProps<{
        bets: IBet[];
        isLoaded: boolean;
    }>();

    const columns = [
        { text: '#', width: '50' },
        { text: i18n.t('my_bets_header_id_time'), width: '180' },
        { text: i18n.t('my_bets_header_selection'), width: undefined },
        { text: i18n.t('fantasy_selection_buy_in'), width: '92' },
        { text: i18n.t('my_bets_header_win_loss'), width: '92' },
        { text: i18n.t('my_bets_header_status'), width: '126' },
    ];
</script>

<style lang="scss">
    @import "@/components/fantasySelection/myBets/BetsTable";
</style>
